import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { translationRequest } from "./i18nBackend";

let store: any = undefined;

export const injectStoreForI18n = (_store: any) => {
  store = _store;
};

export const APP_LANGUAGE_STORAGE_KEY = "APP_LANGUAGE";

const baseUrl = process.env.REACT_APP_ABFSSL_API_BASE_URL || "";

export type T_AppLanguage = "en" | "hi" | "mr" | "gu" | "ta" | "kn" | "te";

export const SUPPORTED_LANGUAGES: ReadonlyArray<T_AppLanguage> = [
  "en",
  "hi",
  "mr",
  "gu",
  "ta",
  "kn",
  "te",
];

export const isSupportedLanguage = (lang: string): lang is T_AppLanguage =>
  SUPPORTED_LANGUAGES.includes(lang as T_AppLanguage);

export const getPersistedLanguage = (): T_AppLanguage => {
  try {
    const fromReduxStore =
      store?.getState()?.CsAppSlice?.userDetails?.preferredLanguage;
    if (fromReduxStore && isSupportedLanguage(fromReduxStore)) {
      return fromReduxStore;
    }
  } catch {
    // Ignore localStorage read issues and continue to sessionStorage fallback.
  }

  return "en";
};

void i18next
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getPersistedLanguage(),
    fallbackLng: "en",
    ns: ["common", "homeLoan"],
    defaultNS: ["common", "homeLoan"],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      // loadPath: `${baseUrl}/utility/fetch-translation-content?lng={{lng}}&ns={{ns}}`,
      // request: translationRequest,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    saveMissing: process.env.NODE_ENV === "development",
    missingKeyHandler:
      process.env.NODE_ENV === "development"
        ? (lngs, ns, key) => {
            console.warn("[i18n] Missing key details:", {
              key,
              ns,
              langs: lngs.join(","),
            });
          }
        : undefined,
  });

export const i18n = i18next;

export const loadNamespace = async (
  namespace: string,
  language: T_AppLanguage,
): Promise<void> => {
  try {
    if (!i18n.hasResourceBundle(language, namespace)) {
      await i18n.loadLanguages(language);
    }
    await i18n.loadNamespaces(namespace);
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.warn("[i18n] Failed to load namespace", {
        namespace,
        language,
        error,
      });
    }
  }
};

export const mergeNamespaceBundle = (
  namespace: string,
  language: T_AppLanguage,
  incoming: Record<string, unknown>,
): void => {
  i18n.addResourceBundle(language, namespace, incoming, true, true);
};

export default i18n;
